// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__HVp5F","Label":"Checkbox_Label__CEWkf","InputElement":"Checkbox_InputElement__3nKLO","Invalid":"Checkbox_Invalid__gZm_1"};